<template>

    <span>

        <v-text-field 
            :hide-details="hideDetails" 
            :autofocus="autofocus"  
            :error-messages="errorMessages" 
            v-model="model" 
            :label="label"
            :disabled="disabled || (code && (!user && !user.is_master) && (!user && !user.is_internal))"
            :readonly="readonly || (code && (!user && !user.is_master) && (!user && !user.is_internal))"
        >

            <template v-slot:append>
                <emc-info-help 
                    v-if="code || textHelper"
                    :icon-color="code ? 'error' : 'indigo'" 
                    title="Informações" 
                    :text="textHelper ? textHelper : 'Código externo utilizado para integração com outros sistemas. É permitido alteração apenas pelo administrador.'" 
                    />
            </template>

        </v-text-field>
    </span>

</template>

<script>

import { mapState } from 'vuex'

export default {
    name: "FormTextField",
    props: {
        value: { type: [String, Number] },
        autofocus: { type: Boolean, default: false },
        label: { type: String, required: false },
        errorMessages: { type: Array, required: false },
        code: { type: Boolean, default: false },
        textHelper: { type: String, required: false },
        readonly: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
    },
    computed: {
        ...mapState('auth', ['user']),
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        hideDetails: {
            get() {

                if(this.errorMessages === undefined) {
                    return true
                }

                return Object.keys(this.errorMessages) ? false : true
            }
        },
    },
}
</script>